import { GetServerSidePropsContext } from 'next/types';
import { setupAPIClient } from '@/services/api';
import { INotification } from '@/types/api/notifications';

interface IGetAllNOtificationParams {
  currentPage?: number;
  url?: string;
  pageSize?: number;
  ordering?: string;
}

export const getAllNotifications = async (
  { currentPage, url, pageSize = 6, ordering }: IGetAllNOtificationParams,
  context?: GetServerSidePropsContext
) => {
  const generateApiParams = !url
    ? {
        params: {
          page: currentPage,
          page_size: pageSize,
          ordering,
        },
      }
    : undefined;

  const { status: statusResponse, data } = await setupAPIClient(context).get<{
    results: INotification[];
    next: string;
  }>(url || '/api/notifications/', generateApiParams);

  if (statusResponse === 200) {
    const newNotifications = data.results;
    const nextPage = data.next;

    return {
      notifications: newNotifications,
      nextPage,
    };
  }

  throw 'Falha ao carregar as notificações';
};
